import { api, ENDPOINTS } from '../config';
import type { PMVMetricResponseData, PMVParams, PMVResponse, PMVResponseData } from './types';

/**
 * Fetch devices with optional filters
 */

export async function getPMVPhysicalMetric(params?: PMVMetricParams): Promise<PMVMetricResponseData[]> {
  const response = await api.get(ENDPOINTS.PMVMETRIC, {
    params,
  });
  
  return response.data;
}

export async function getPMV(): Promise<PMVResponseData> {
  const response = await api.get<PMVResponse>(ENDPOINTS.PMV);
  
  return response.data;
}

export async function patchPmv(params?: PMVParams): Promise<PMVResponseData> {
  const response = await api.patch<PMVResponse>(`${ENDPOINTS.PMV}1/`, {
    ...params,
  });
  
  return response.data;
}
